import React from 'react'
import { NavLink } from 'react-router-dom'

import './NavLink.css'

const NavLinkComponent = ({ className, children, ...props }) => (
  <NavLink {...props} className={`NavLink ${className || ''}`}>
    {children}
  </NavLink>
)

export default NavLinkComponent
